export default {
  jobs: [],
  jodDetail: {}
}
